/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-19 20:30:46
 * @FilePath: /src/components/GlobalInitializerV2/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';
import { useReporting } from '@/hooks/useReporting';
// import useThirdPartyLogin from '@/hooks/useThirdPartyLogin';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import appCommunicationManager, {
  EAppCommunicationFuncName,
} from '@/utils/app-communication-manager';
import { NO_SCROLL_TO_TOP_PAGE_LIST } from '@/utils/constants';
import { EPlatform } from '@/utils/enums/platform-enum';
import { env } from '@/utils/env';
import { getRouteCnName } from '@/utils/route-metadata';
import { isInZeloolApp } from '@/utils/tools';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useAwinBindInit } from './useAwinBindInit';
import { usePepperjamBindInit } from './usePepperjamBindInit';
import { useEventListenInit } from './useEventListenInit';
import { useEventReportingInit } from './useEventReportingInit';
import { useImpactBindInit } from './useImpactBindInit';
import { useQueryParamsInit } from './useQueryParamsInit';
import { useStorageDataInit } from './useStorageDataInit';
import { useClientDataInit } from './useClientDataInit';

interface GlobalDataInitializerProps {
  deviceType: EPlatform;
}

/**
 * 全局副作用初始化（不含 global init 接口：已由 useGlobalShellInit / GlobalLayoutShell 统一处理）
 */
const GlobalInitializer = ({ deviceType }: GlobalDataInitializerProps) => {
  const setInAppH5 = useStore((state) => state.setInAppH5);
  const setIsGlobalLoading = useStore((state) => state.setIsGlobalLoading);
  const pathname = usePathname();
  const prevPathname = useRef<string | null>(null);
  const { trackEvent } = useReporting();

  useClientDataInit();

  // 初始化跟storage相关的处理
  useStorageDataInit();

  // 初始化事件监听
  useEventListenInit();

  // 初始化事件上报相关的处理
  useEventReportingInit({ deviceType });

  // 初始化query参数相关的处理
  useQueryParamsInit();

  // 初始化Impact绑定处理
  useImpactBindInit();

  // 初始化Awin绑定处理
  useAwinBindInit();

  // 初始化 Pepperjam 绑定处理
  usePepperjamBindInit();

  // 初始化第三方登录处理 已经在 GlobalDialog 中进行加载了
  // useThirdPartyLogin();

  useEffect(() => {
    if (isInZeloolApp()) {
      appCommunicationManager.sendMessage(EAppCommunicationFuncName.WEB_PAGE_INFO, {
        refer_page_name: getRouteCnName(pathname),
        refer_url_path: window.location.href,
      });
      setInAppH5(true);
    }
    // 只有在页面切换时才触发（排除首次加载）
    if (prevPathname.current !== null) {
      // 路由切换完成，关闭全局 Loading
      setIsGlobalLoading(false);

      // setIsWebPushed(true);
      // 这里等价于vue监听的$router.name

      // 切换页面的时候GA4更新页面数据
      const userId = localStorage.getItem('zl-userId') || '';
      if (window.gtag) {
        trackEvent(
          {
            commandType: 'config',
            eventName: env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
            properties: {
              page_path: pathname,
              page_location: location.origin + pathname,
            },
          },
          [ProviderType.GA4],
        );
        trackEvent(
          {
            commandType: 'set',
            eventName: env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
            properties: {
              page_path: pathname,
              page_location: location.origin + pathname,
            },
          },
          [ProviderType.GA4],
        );
        // 这种写法，没得兼容啊！所以只能用gtag原生的了
        window.gtag('set', { user_id: userId });
      }
      // 结束

      if (
        !NO_SCROLL_TO_TOP_PAGE_LIST.some((path) => {
          if (path === '/') {
            return pathname === '/';
          } else {
            return pathname === path || pathname?.startsWith(`${path}/`);
          }
        })
      ) {
        window.scrollTo(0, 0);
      }
    }
    // APPLOVIN的埋点上报
    trackEvent(
      {
        eventName: 'page_view',
      },
      [ProviderType.APPLOVIN],
    );

    // 更新前一个pathname
    prevPathname.current = pathname;
  }, [pathname, setIsGlobalLoading]);

  // 这个组件不需要渲染任何内容
  return null;
};

export default GlobalInitializer;
